// todo: there's a duplicate of this in vme-jobs.component.ts, needs to not be
export enum TaskType {
  DrivenPlated = 1,
  DrivenUninsured = 2,
  UncoveredTransportedMovement = 3,
  CoveredTransportedMovement = 4,
  RecoveredSkates = 5,
  RecoveredFullLiftOnly = 6,
  RecoveredMoreEquipmentNeeded = 7,
  DriverInsured = 9,
  DrivenPrestige = 10,
  DrivenEngineiusGo = 11,
  DrivenTurnaround = 12,
  RecoveryStandard = 8,
  Inspection = 14,
  DrivenInsuredInspection = 15,
  DrivenPlatedInspection = 16,
  PrestigeTransported = 17,
}
